import { render } from "./IncomeCategoryReport.vue?vue&type=template&id=797ca188"
import script from "./IncomeCategoryReport.vue?vue&type=script&lang=js"
export * from "./IncomeCategoryReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__